/* eslint-disable */ 
import React, { useState, useEffect } from "react";
import "../userAuthorization.css";
import { useFormik } from "formik";
import { message, notification, Button, Select } from "antd";
// import axiosInstance from "../../../../axios";

import googleIcon from "../../../../assets/images/login-google.png";
import facebookIcon from "../../../../assets/images/login-facebook.png";
import twitterIcon from "../../../../assets/images/login-twitter.png";
import StudentIcon from "../../../../assets/images/studenticon.png";
import TutorIcon from "../../../../assets/images/tutoricon.png";
import LoaderUi from "../../../../UiLoader/Loader";

import { countries } from "../../../../shared/countriesData/CountriesData";
import { timezone } from "../../../../shared/timeZoneData/TimeZone";
import { GET, POST } from '../../../../apiClient';




const SignupModal = (props) => {
  const [isStudentSignup, setStudentSignup] = useState(false);
  const [isStudentSignupStep, setStudentSignupStep] = useState(false);
  const [isTutorSignup, setTutorSignup] = useState(false);
  const [isTutorSignupStep, setTutorSignupStep] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [allCountries, setCountries] = useState(null);
  const [allTimeZones, setTimeZones] = useState(null);
  const [isChecked, setChecked] = useState(false);
  const [isSubmitted, setSubmitted] = useState(false);

  const [islanguages, setlanguages] = useState([
    "English",
    "Urdu",
    "Arabic",
    "Persian",
    "French",
  ]);
  const [isUpdatelanguages, setUpdatelanguages] = useState([]);

  const studentInitialValues = {
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    cellNumber: "",
    dob: "",
    gender: "",
    password: "",
    timezone: "",
    country: "",
    state: "",
    city: "",
    languages: [],
    subjects: ""
  };

  // student form on submit function will be handle from here explicitly
  const studentOnSubmit = async (values) => {
    console.log("HIT");
    const data = {
      about: "I want to learn " + values.subjects.toString(),
      firstName: values.firstName,
      lastName: values.lastName,
      username: values.firstName + ' ' + values.lastName,
      email: values.email,
      cellNumber: values.cellNumber,
      dob: values.dob,
      gender: values.gender,
      password: values.password,
      timezone: values.timezone,
      country: values.country,
      state: values.state,
      city: values.city,
      languages: values.languages,
      subjects: values.subjects,
      userRole: "student",
      link: "https://nida-ul-quran.web.app/home",
    };

    if(!isChecked){
      return;
    }
    if(studentFormik.getFieldProps("confirmpassword").value !== studentFormik.getFieldProps("password").value){
      return notification.error({message:'Password must match with confirm password'})
    }

    try {
      const signupUser = await POST("student/signup", data);
      if (signupUser.status === 200) {
        // props.closeModal();
        setLoading(true);
        message
          .loading("Creating account.....")
          .then(() => {
            const key = `open${Date.now()}s`;
            const btn = ( <Button type="primary" size="small" onClick={() => notification.close(key)}>Close</Button> );
            notification.success({
              message: "Your Account",
              description:
                "Account created successfully and Verification Link has been sent to your Email please Verify before login.",
              className: "custom-class",
              placement: 'topLeft',
              style: {
                width: '600',
              },
              btn: btn,
              key: key,
              onClose: close,
              duration: 0
            });
          })
          .then(() => {
            setLoading(false);
            props.closeModal();
            props.showSignupModal("login");
          });
      }
      if (signupUser.status === 500) {
        notification.error({message:signupUser.err.error.message})
        }
    } catch (error) {
      message.error("something went wrong", error.message);
    }
  };

  // student form validating
  const studentValidate = (values) => {
    let errors = {};

    if (!values.firstName) {
      errors.firstName = "First name required";
    }
    if (!values.lastName) {
      errors.lastName = "Last name required";
    }
    if (!values.cellNumber) {
      errors.cellNumber = "Phone number required";
    }
    if (!values.gender) {
      errors.gender = "Gender required";
    }
    if (!values.dob) {
      errors.dob = "Date of Birth required";
    }
    if (!values.timezone) {
      errors.timezone = "Timezone required";
    }
    if (!values.country) {
      errors.country = "Country required";
    }
    if (!values.state) {
      errors.state = "State required";
    }
    if (!values.city) {
      errors.city = "City required";
    }
    if (!values.languages || values.languages.length == 0) {
      errors.languages = "Language required";
    }
    if (!values.email) {
      errors.email = "Email required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Invalid email format";
    }
    if (!values.password) {
      errors.password = "Please fill the password field";
    }
    return errors;
  };

  const studentFormik = useFormik({
    initialValues: studentInitialValues,

    onSubmit: studentOnSubmit,
    validate: studentValidate,
  });

  console.log("studnet error", studentFormik.errors);

  const tutorIntialValues = {
    username: "",
    email: "",
    password: "",
    country: "",
    timeZone: "",
    city: "",
    skills: "",
    link: "https://nida-ul-quran.web.app/home",
  };

  // tutor form on submit function will be handle from here explicitly
  const tutorOnSubmit = async (values) => {
    console.log("HIT");
    const data = {
      username: values.username,
      email: values.email,
      password: values.password,
      country: values.country,
      timezone: values.timezone,
      city: values.city,
      skills: values.skills,
      userRole: "tutor",
    };
    console.log("tutor data", data);
    try {
      if (isChecked) {

        const signupUser = await POST("tutor/signup", data);
        if (signupUser.status === 200) {
          setLoading(true);
          setSubmitted(false);
          message
            .loading("Creating account.....")
            .then(() => {
              const key = `open${Date.now()}t`;
              const btn = ( <Button type="primary" size="small" onClick={() => notification.close(key)}>Close</Button> );
              notification.success({                
                message: "Your Account",
                description:
                  "Account created successfully and Verification Link has been sent to your Email please Verify before login.",
                className: "custom-class",
                style: {
                  width: '600',
                },
                btn: btn,
                key: key,
                onClose: close,
                duration: 0
              });
            })
            .then(() => {
              setLoading(false);
              props.closeModal();
              props.showSignupModal("login");
            });
        }
        console.log(signupUser)
        if (signupUser.status === 409) {
        notification.error({message:signupUser.err.message})
        }
        if (signupUser.status === 500) {
          notification.error({message:signupUser.err.error.message})
          }
      }
    } catch (error) {
      message.error("something went wrong");
    }
  };
  // tutor validation function
  const tutorValidate = (values) => {
    let errors = {};

    if (!values.username) {
      errors.username = "Enter Tutor user name ";
    }
    if (!values.email) {
      errors.email = "Email Required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Invalid email format";
    }
    if (!values.password) {
      errors.password = "Please fill the password field";
    }
    if (!values.city) {
      errors.city = "Select your city";
    }
    return errors;
  };

  const tutorFormik = useFormik({
    initialValues: tutorIntialValues,

    onSubmit: tutorOnSubmit,
    validate: tutorValidate,
  });
  console.log("tutor errors:", tutorFormik.errors);

  const termsAndConditionsHAndler = (check) => {
    console.log("termsAndConditionsHAndler", check.target.checked);
    setChecked(!isChecked);
  };
  useEffect(() => {
    setCountries(countries);
    setTimeZones(timezone);
  }, []);

  const close = () => {
    console.log('Notification was closed.');
  };  
  
  const languagesChangeHandler = (value) => {
    setUpdatelanguages(value);
    studentFormik.values.languages = value;
  };

  return (
    <>
      <div className="popup-wrap" onClick={props.closeModal}></div>
      {isLoading ? <LoaderUi /> : null}
      <div id="signup" className="popup clearfix pop-up-new">
        <div className="popup-contentleft">
          <div className="popupcontent">
            <div className="content-box">
              <div className="content-tabsbtn">
                <ul>
                  <li>
                    <a onClick={() => props.showSignupModal("login")}>Log In</a>
                  </li>
                  <li
                    className="active"
                    onClick={() => {
                      setStudentSignup(false);
                      setTutorSignup(false);
                      setTutorSignupStep(false);
                    }}
                  >
                    <a >Sign Up</a>
                  </li>
                </ul>
              </div>

              {/* student SignUp Form */}
              {isStudentSignup ? (
                <>
                  <div className="login-form">
                    <form onSubmit={studentFormik.handleSubmit}>
                      
                      {/* <div className="form-control">
                        <label htmlFor="email">User Name</label>
                        <input
                          id="username"
                          name="username"
                          type="username"
                          {...studentFormik.getFieldProps("username")}
                          placeholder="Student name"
                        />
                        {studentFormik.touched.username &&
                          studentFormik.errors.username ? (
                            <div className="error">
                              {" "}
                              {studentFormik.errors.username}
                            </div>
                          ) : null}
                      </div> */}

                      <div className="edit-row clearfix">
                        <div className="editcol-left">
                          <label>First Name</label>
                          <input
                            type="text"
                            name="firstName"
                            {...studentFormik.getFieldProps("firstName")}
                            placeholder="First Name"                            
                          />
                          {studentFormik.touched.firstName && studentFormik.errors.firstName ? (
                          <div className="error"> {studentFormik.errors.firstName}</div>
                        ) : null}
                        </div>
                        <div className="editcol-right">
                          <label>Last Name</label>
                          <input
                            type="text"
                            name="lastName"
                            placeholder="Last Name"
                            onChange={studentFormik.handleChange}
                          />
                          {studentFormik.touched.lastName && studentFormik.errors.lastName ? (
                          <div className="error"> {studentFormik.errors.lastName}</div>
                        ) : null}
                        </div>
                      </div>

                      <label htmlFor="email">Email Address</label>
                      <input
                        id="email"
                        name="email"
                        type="email"
                        {...studentFormik.getFieldProps("email")}
                        placeholder="example@abc.com"
                      />
                      {studentFormik.touched.email &&
                        studentFormik.errors.email ? (
                          <div className="error">
                            {" "}
                            {studentFormik.errors.email}
                          </div>
                        ) : null}

                      <label>Phone Number</label>
                      <input
                        id="cellNumber"
                        type="tel"
                        name="cellNumber"
                        {...studentFormik.getFieldProps("cellNumber")}
                        placeholder="207-773-0927"
                      />
                      {studentFormik.touched.cellNumber && studentFormik.errors.cellNumber ? (
                          <div className="error"> {studentFormik.errors.cellNumber}</div>
                        ) : null}

                      <div className="edit-row clearfix">
                        <div className="editcol-left">
                          <label>Date of Birth</label>
                          <input
                            type="date"
                            name="dob"
                            defaultValue={
                              studentFormik.values.dob
                            }
                            onChange={studentFormik.handleChange}
                          />
                          {studentFormik.touched.dob && studentFormik.errors.dob ? (
                          <div className="error"> {studentFormik.errors.dob}</div>
                        ) : null}
                        </div>
                        <div className="editcol-right">
                          <label>Gender</label>
                          <select
                            name="gender"
                            value={
                              studentFormik.values.gender
                            }
                            onChange={studentFormik.handleChange}
                          >
                            <option label="Select Gender"></option>
                            <option value="Male" label="Male">
                              Male
                            </option>
                            <option value="Female" label="Female">
                              Female
                            </option>
                          </select>
                          {studentFormik.touched.gender && studentFormik.errors.gender ? (
                            <div className="error"> {studentFormik.errors.gender}</div>
                            ) : null}
                        </div>
                      </div>                      
                      
                      <label htmlFor="firstName">Password</label>
                      <input
                        id="password"
                        name="password"
                        type="password"
                        {...studentFormik.getFieldProps("password")}
                        placeholder="Enter passowrd"
                      />
                      {studentFormik.touched.password &&
                        studentFormik.errors.password ? (
                          <div className="error">
                            {" "}
                            {studentFormik.errors.password}
                          </div>
                        ) : null}

                      <label>Confirm Password</label>
                      <input
                        id="confirmPassword"
                        name="confirmpassword"
                        type="password"
                        {...studentFormik.getFieldProps("confirmpassword")}
                        placeholder="Confirm password"
                      />
                      {studentFormik.touched.password &&
                        studentFormik.errors.password ? (
                          <div className="error">
                            {studentFormik.errors.password}
                          </div>
                        ) : null}
                      
                      <a
                        className="default-btn"
                        onClick={() => {

                          console.log(studentFormik.getFieldProps("confirmpassword"))
                          console.log(studentFormik.getFieldProps("password"))
                          if(studentFormik.getFieldProps("confirmpassword").value !== studentFormik.getFieldProps("password").value){
                              return notification.error({message:'Password must match with confirm password'})
                          }
                          setStudentSignupStep(true);
                          setStudentSignup(false);
                          setTutorSignup(false);
                        }}
                      >
                        Next
                      </a>
                      <div className="round-btn">
                        <ul>
                          <li
                            onClick={() => {
                              setStudentSignup(true);
                              setStudentSignupStep(false);
                            }}
                          >
                            {/* <a href="/" className="active"></a> */}
                          </li>
                          <li
                            onClick={() => {
                              setStudentSignup(false);
                              setStudentSignupStep(true);
                            }}
                          >
                            <a ></a>
                          </li>
                        </ul>
                      </div>
                    </form>
                  </div>
                </>
              ) : isStudentSignupStep ? (
                <>
                  <div id="signupstudentstep-2" className="login-form">
                    <form onSubmit={studentFormik.handleSubmit}>

                    <label>Time Zone</label>
                      <select
                        id="timezone"
                        name="timezone"
                        value={studentFormik.values.timezone}
                        onChange={studentFormik.handleChange}
                        onBlur={studentFormik.handleBlur}
                      >
                        <option value="default">Select timezone</option>
                        {timezone.map((tmz) => (
                          <option value={tmz.text}>{tmz.text}</option>
                        ))}
                      </select>
                      {studentFormik.touched.timezone && studentFormik.errors.timezone ? (
                            <div className="error"> {studentFormik.errors.timezone}</div>
                            ) : null}

                      <label>Country</label>
                      <select
                        id="country"
                        name="country"
                        value={studentFormik.values.country}
                        onChange={studentFormik.handleChange}
                        onBlur={studentFormik.handleBlur}
                      >
                        <option value="default">Select country</option>
                        {allCountries.map((country) => (
                          <option key={country.code} value={country.name}>
                            {country.name}
                          </option>
                        ))}
                      </select>                      
                      {studentFormik.touched.country && studentFormik.errors.country ? (
                            <div className="error"> {studentFormik.errors.country}</div>
                            ) : null}

                      <div className="edit-row clearfix">
                        <div className="editcol-left">
                          <label>State</label>
                          <input
                            id="state"
                            name="state"
                            type="text"
                            {...studentFormik.getFieldProps("state")}
                          />
                          {studentFormik.touched.state && studentFormik.errors.state ? (
                            <div className="error">{studentFormik.errors.state}</div>
                          ) : null}
                        </div>
                        <div className="editcol-right">
                          <label>City</label>
                          <input
                            id="city"
                            name="city"
                            type="text"
                            {...studentFormik.getFieldProps("city")}
                          />
                          {studentFormik.touched.city && studentFormik.errors.city ? (
                            <div className="error">{studentFormik.errors.city}</div>
                          ) : null}
                        </div>
                      </div>

                      <label>Languages</label>
                      <Select
                        mode="multiple"
                        style={{ width: "100%", backgroundColor: "#edf0f8" }}
                        name="languages"
                        placeholder="Please select"
                        value={isUpdatelanguages || studentFormik.values.languages}
                        onChange={languagesChangeHandler}
                      >
                        {islanguages.map((lang) => (
                          <Option key={lang}>{lang}</Option>
                        ))}
                      </Select>
                      {studentFormik.touched.languages && studentFormik.errors.languages ? (
                          <div className="error"> {studentFormik.errors.languages}</div>
                        ) : null}

                      <div className="more-skills">
                        <label style={{ marginBottom: "10px", marginTop: "20px" }}>I want to learn</label>
                        <label className="containercheckbox">
                          Recitation
                          <input
                            type="checkbox"
                            name="subjects"
                            value="recitation"
                            onChange={studentFormik.handleChange}
                            onBlur={studentFormik.handleBlur}
                          />
                          <span className="checkmark"></span>
                        </label>
                        <label className="containercheckbox">
                          Arabic
                          <input
                            type="checkbox"
                            name="subjects"
                            value="arabic"
                            onChange={studentFormik.handleChange}
                            onBlur={studentFormik.handleBlur}
                          />
                          <span className="checkmark"></span>
                        </label>
                        <label className="containercheckbox">
                          Hifz
                          <input
                            type="checkbox"
                            name="subjects"
                            value="hifz"
                            onChange={studentFormik.handleChange}
                            onBlur={studentFormik.handleBlur}
                          />
                          <span className="checkmark"></span>
                        </label>
                        <label className="containercheckbox">
                          Tajweed
                          <input
                            type="checkbox"
                            name="subjects"
                            value="tajweed"
                            onChange={studentFormik.handleChange}
                            onBlur={studentFormik.handleBlur}
                          />
                          <span className="checkmark"></span>
                        </label>

                        <label className="w-100 containercheckbox">
                          Islamic Studies
                          <input
                            type="checkbox"
                            name="subjects"
                            value="islamicStudies"
                            onChange={studentFormik.handleChange}
                            onBlur={studentFormik.handleBlur}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </div>

                      <br/>
                      <div className="otherinfo">
                        <label
                          className="containercheckbox"
                          onChange={termsAndConditionsHAndler}
                        >
                          I have read and agree to the{" "}
                          <a href="/home/rules"> terms of use</a>
                          <input type="checkbox" checked={isChecked} />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                      {!isChecked && (
                        <p style={{ color: "crimson", fontSize: "12px" }}>
                          You have to accept terms and conditions befor signup{" "}
                        </p>
                      )}
                      <input
                        type="submit"
                        value="Sign Up"
                        className="default-btn"
                      />
                      <div className="round-btn">
                        <ul>
                          <li
                            onClick={() => {
                              setStudentSignup(true);
                              setStudentSignupStep(false);
                            }}
                          >
                            <a ></a>
                          </li>
                          <li
                            onClick={() => {
                              setStudentSignup(false);
                              setStudentSignupStep(true);
                            }}
                          >
                            <a className="active"></a>
                          </li>
                        </ul>
                      </div>
                    </form>
                  </div>
                </>
			        ): isTutorSignup ? (
                <>
                  <div id="signuptutorstep-1" className="login-form">
                    <form>
                      <div>
                        <label>User Name</label>
                        <input
                          id="username"
                          name="username"
                          type="text"
                          {...tutorFormik.getFieldProps("username")}
                          placeholder="Enter tutor name"
                        />
                        {tutorFormik.touched.username &&
                          tutorFormik.errors.username ? (
                            <div className="error">
                              {" "}
                              {tutorFormik.errors.username}
                            </div>
                          ) : null}
                      </div>

                      <label>Email</label>
                      <input
                        id="email"
                        name="email"
                        type="email"
                        {...tutorFormik.getFieldProps("email")}
                        placeholder="exameple@abc.com"
                      />
                      {tutorFormik.touched.email && tutorFormik.errors.email ? (
                        <div className="error">{tutorFormik.errors.email}</div>
                      ) : null}
                      <label>Password</label>
                      <input
                        id="password"
                        name="password"
                        type="password"
                        {...tutorFormik.getFieldProps("password")}
                        placeholder="Enter password"
                      />
                      {tutorFormik.touched.password &&
                        tutorFormik.errors.password ? (
                          <div className="error">
                            {tutorFormik.errors.password}
                          </div>
                        ) : null}
                      <label>Confirm Password</label>
                      <input
                        id="confirmPassword"
                        name="confirmpassword"
                        type="password"
                        {...tutorFormik.getFieldProps("confirmpassword")}
                        placeholder="Confirm password"
                      />
                      {tutorFormik.touched.password &&
                        tutorFormik.errors.password ? (
                          <div className="error">
                            {tutorFormik.errors.password}
                          </div>
                        ) : null}

                      <a
                        className="default-btn"
                        onClick={() => {

                          console.log(tutorFormik.getFieldProps("confirmpassword"))
                          console.log(tutorFormik.getFieldProps("password"))
                          if(tutorFormik.getFieldProps("confirmpassword").value !== tutorFormik.getFieldProps("password").value){
                              return notification.error({message:'Password must match with confirm password'})
                          }
                          setTutorSignupStep(true);
                          setTutorSignup(false);
                          setStudentSignup(false);
                        }}
                      >
                        Next
                      </a>
                      <div className="round-btn">
                        <ul>
                          <li
                            onClick={() => {
                              setTutorSignup(true);
                              setTutorSignupStep(false);
                            }}
                          >
                            {/* <a href="/" className="active"></a> */}
                          </li>
                          <li
                            onClick={() => {
                              setTutorSignup(false);
                              setTutorSignupStep(true);
                            }}
                          >
                            <a ></a>
                          </li>
                        </ul>
                      </div>
                    </form>
                  </div>
                </>
              ) : isTutorSignupStep ? (
                <>
                  <div id="signuptutorstep-2" className="login-form">
                    <form onSubmit={tutorFormik.handleSubmit}>
                      <label>Country</label>
                      <select
                        id="country"
                        name="country"
                        value={tutorFormik.values.country}
                        onChange={tutorFormik.handleChange}
                        onBlur={tutorFormik.handleBlur}
                      >
                        <option value="default">Select country</option>
                        {allCountries.map((country) => (
                          <option key={country.code} value={country.name}>
                            {country.name}
                          </option>
                        ))}
                      </select>

                      <label>Time Zone</label>
                      <select
                        id="timezone"
                        name="timezone"
                        value={tutorFormik.values.timezone}
                        onChange={tutorFormik.handleChange}
                        onBlur={tutorFormik.handleBlur}
                      >
                        <option value="default">Select timezone</option>
                        {timezone.map((tmz) => (
                          <option value={tmz.text}>{tmz.text}</option>
                        ))}
                      </select>

                      <label>City</label>
                      <div className="form-control">
                        <input
                          id="city"
                          name="city"
                          type="text"
                          {...tutorFormik.getFieldProps("city")}
                        />
                        {tutorFormik.touched.city && tutorFormik.errors.city ? (
                          <div className="error">{tutorFormik.errors.city}</div>
                        ) : null}
                      </div>
                      <div className="more-skills">
                        <label>I Can Teach</label>
                        <label className="containercheckbox">
                          Recitation
                          <input
                            type="checkbox"
                            name="skills"
                            value="recitation"
                            onChange={tutorFormik.handleChange}
                            onBlur={tutorFormik.handleBlur}
                          />
                          <span className="checkmark"></span>
                        </label>
                        <label className="containercheckbox">
                          Arabic
                          <input
                            type="checkbox"
                            name="skills"
                            value="arabic"
                            onChange={tutorFormik.handleChange}
                            onBlur={tutorFormik.handleBlur}
                          />
                          <span className="checkmark"></span>
                        </label>
                        <label className="containercheckbox">
                          Hifz
                          <input
                            type="checkbox"
                            name="skills"
                            value="hifz"
                            onChange={tutorFormik.handleChange}
                            onBlur={tutorFormik.handleBlur}
                          />
                          <span className="checkmark"></span>
                        </label>
                        <label className="containercheckbox">
                          Tajweed
                          <input
                            type="checkbox"
                            name="skills"
                            value="tajweed"
                            onChange={tutorFormik.handleChange}
                            onBlur={tutorFormik.handleBlur}
                          />
                          <span className="checkmark"></span>
                        </label>

                        <label className="w-100  containercheckbox">
                          Islamic Studies
                          <input
                            type="checkbox"
                            name="skills"
                            value="islamicStudies"
                            onChange={tutorFormik.handleChange}
                            onBlur={tutorFormik.handleBlur}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                      <div className="otherinfo">
                        <label
                          className="containercheckbox"
                          onChange={termsAndConditionsHAndler}
                        >
                          I have read and agree to the{" "}
                          <a href="/home/rules"> terms of use</a>
                          <input type="checkbox" checked={isChecked} />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                      {!isChecked && (
                        <p style={{ color: "crimson", fontSize: "12px" }}>
                          You have to accept terms and conditions befor signup{" "}
                        </p>
                      )}
                      <input
                        type="submit"
                        value="Sign Up"
                        className="default-btn"
                      />
                      <div className="round-btn">
                        <ul>
                          <li
                            onClick={() => {
                              setTutorSignup(true);
                              setTutorSignupStep(false);
                            }}
                          >
                            <a ></a>
                          </li>
                          <li
                            onClick={() => {
                              setTutorSignup(false);
                              setTutorSignupStep(true);
                            }}
                          >
                            <a className="active"></a>
                          </li>
                        </ul>
                      </div>
                    </form>
                  </div>
                </>
              ) : (
                      <>
                        <div className="login-form">
                          <form>
                            <div className="signup-option">
                              <ul>
                                <li>
                                  <a
                                    className="studentsignup"
                                    onClick={() => setStudentSignup(true)}
                                  >
                                    <span>
                                      <img src={StudentIcon} alt="" />
                                    </span>{" "}
                                    <em>Sign Up As A Student</em>
                                  </a>
                                </li>
                                <li onClick={() => setTutorSignup(true)}>
                                  <a className="tutorsignup">
                                    <span>
                                      <img src={TutorIcon} alt="" />
                                    </span>{" "}
                                    <em>Sign Up As A Tutor</em>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </form>
                        </div>
                      </>
                    )}
            </div>
          </div>
          <p>
            © 2020 Nida Ul Quran. All rights reserved. | <a >Privacy Policy</a>
          </p>
        </div>
        <div className="popup-contentright">
          <div className="popupcontent">
            <div className="overlaypopup"></div>
            <div className="inner-content">
              {isStudentSignup || isStudentSignupStep ? (
                <>
                  {/* if signup as student then content is*/}
                  <div className="content">
                    <h3>Sign Up As Student</h3>
                    <h4>Rules and Regulations for Student</h4>
                    <div className="rules-wrapper">
                      <p>
                        1. A respectful demeanour towards the teacher must be adopted during the class, otherwise the management will take serious action.
                      </p>
                      <p>
                        2. The scheduled class time should be respected, and the student should not be late for class. If there are any concerns the student can contact the teacher at any time.
                      </p>
                      <p>
                        3. The platform should only be used to contact teachers for personal education and should not be used to search for teachers to hire them for any other institutes, in such cases the student’s profile will be blocked.
                      </p>
                      <p>
                        4. The student can choose more then one teacher as a tutor to learn from.
                      </p>
                      <p>
                        5. There should not be any fake information added to the personal profile or at the payment process.
                      </p>
                      <p>
                        6. The student is encouraged to inform the teacher in cases where due to some emergency or personal reason he/she will be late or miss the scheduled class.
                      </p>
                      <p>
                        7. The misuse of the system has to be avoided at all times.
                      </p>
                      <strong>
                        <p>Barak Allahu Feekum!</p>
                      </strong>
                    </div>
                  </div>
                </>
              ) : isTutorSignup || isTutorSignupStep ? (
                <>
                  <div className="content">
                    <h3>Sign Up As Tutor</h3>
                    <h4>Rules and Regulations for Tutor</h4>
                    <div className="rules-wrapper">
                      <p>
                        1. There should not be unnecessary disturbances or
                        background noise during the Class.{" "}
                      </p>
                      <p>
                        2. The teacher must not be late for the class, all
                        classes must commence on the scheduled time, if the
                        teacher is late more then once then appropriate steps
                        against the teacher will be taken.
                      </p>
                      <p>
                        3. The class should not be left earlier then its due
                        completion time.
                      </p>
                      <p>
                        4. If the teacher has to miss a scheduled class due to
                        some personal emergency, then he/she has to inform the
                        students in advance and reschedule the class.
                      </p>
                      <p>
                        5. The mode of communication should be respectful, and
                        the teacher should be professional in his conduct with
                        the student.
                      </p>
                      <p>
                        6. The teachers inactive on the platform for more then
                        three weeks will be removed.
                      </p>
                      <p>
                        7. The profile information should be filled out in
                        complete and honestly, if the teacher is found out to
                        have filled fake information then appropriate steps
                        against him will be taken.
                      </p>
                      <p>
                        8. The management is not to be harassed by the teacher
                        about any matter. Full support will be provided to the
                        teacher at every step of the way.
                      </p>
                      <p>
                        9. The web portal is to be used to convey authentic
                        knowledge only, extremism is always to be avoided when
                        it comes to teaching Islamic literature. Any teacher
                        found guilty of any sort of suspicious activity will be
                        dealt with seriously.
                      </p>
                      <strong>
                        <p>Barak Allahu Feekum!</p>
                      </strong>
                    </div>
                  </div>
                </>
              ) : (
                    <>
                      {/* signup general content  */}
                      <h3>Sign up to Nida Ul Quran</h3>
                      <p>
                        Nida Ul Quran is an online learning platform where you can
                        learnQuran, Memorization (Hifz), Tajweed, Arabic, Islamic
                        studies andmuch more. With the help of highly qualified
                        tutors, you candeeply understand all type of subjects
                        offered by this learningplatform.
                  </p>
                      <a href="/home/about-us">Read more ...</a>
                    </>
                  )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignupModal;
